import styles from "../../../styles/Components/integration/History/ExchangeHistoryTableExpandedRow.module.css";
import { getRelativeTime } from "../../../utility/formatter-helper";
import { IoCheckmarkDoneCircle, IoCloseCircle } from "react-icons/io5";

const getLastOrders = (data) => {
  let lastTakeProfit = null;
  let lastStopLoss = null;
  const triggeredSells = [];

  for (let i = 0; i < (data?.length || 0); i++) {
    if (data[i]["Take Profit Limit Order"]) {
      lastTakeProfit = data[i]["Take Profit Limit Order"];
    }
    if (data[i]["Stop Loss Limit Order"]) {
      lastStopLoss = data[i]["Stop Loss Limit Order"];
    }
    if (data[i]["Triggered Sell Order"]) {
      triggeredSells.push(data[i]["Triggered Sell Order"]);
    }
  }

  return { lastTakeProfit, lastStopLoss, triggeredSells };
};

const sellLooksFailed = (text) => {
  const value = String(text || "").toLowerCase();
  return value.includes("fail") || value.includes("error");
};

function ComprehensiveHistoryTableExpandedRow({ data }) {
  const { lastTakeProfit, lastStopLoss, triggeredSells } = getLastOrders(
    data?.info?.Details,
  );
  const isTakeProfitSuccessfully = lastTakeProfit
    ?.toLowerCase()
    ?.includes("success");
  const isStopLossSuccessfully = lastStopLoss
    ?.toLowerCase()
    ?.includes("success");
  const originalAmount = data?.info?.["Original Amount"];
  const remainingAmount = data?.info?.["Remaining Amount"];
  const positionOpen = data?.info?.Position === "Open" || data?.status === "Open";

  return (
    <div className={styles.container}>
      <ul className={styles.dataList}>
        <li>
          <span className={styles.label}>Trade ID:</span>
          <span>{data?.info?.["Trade ID"]}</span>
        </li>
        <li>
          <span className={styles.label}>Date:</span>
          <span>{getRelativeTime(data?.date)}</span>
        </li>
        <li>
          <span className={styles.label}>Trading Duration</span>
          <span>{data?.info?.["Trading Duration"]}</span>
        </li>
        <li className={styles.smSize}>
          <span className={styles.label}>Trader:</span>
          <span>{data?.trader}</span>
        </li>
        <li className={styles.mdSize}>
          <span className={styles.label}>Amount:</span>
          <span>{data?.amount}</span>
        </li>
        {originalAmount != null && (
          <li>
            <span className={styles.label}>Original Amount:</span>
            <span>{originalAmount}</span>
          </li>
        )}
        {positionOpen && remainingAmount != null && (
          <li>
            <span className={styles.label}>Remaining Amount:</span>
            <span>{remainingAmount}</span>
          </li>
        )}
        <li className={styles.mdSize}>
          <span className={styles.label}>Status:</span>
          <span>{data?.status}</span>
        </li>
        <li className={styles.lgSize}>
          <span className={styles.label}>Position:</span>
          <span>Long</span>
        </li>
        <li className={styles.xlSize}>
          <span className={styles.label}>Entry Price:</span>
          <span>{data?.entryPrice}</span>
        </li>
        <li className={styles.xlSize}>
          <span className={styles.label}>Exit Price:</span>
          <span>{data?.exitPrice}</span>
        </li>
        {triggeredSells.map((sell, index) => {
          const failed = sellLooksFailed(sell);
          return (
            <li key={`${index}-${sell}`} className={failed ? styles.failedOrder : ""}>
              <span className={styles.label}>Triggered Sell Order:</span>
              <span className={`${styles.limitOrderStatus}`}>
                {failed ? (
                  <IoCloseCircle color={"red"} />
                ) : (
                  <IoCheckmarkDoneCircle color={"green"} />
                )}
                {sell}
              </span>
            </li>
          );
        })}
        {lastTakeProfit && (
          <li
            className={`${!isTakeProfitSuccessfully ? styles.failedOrder : ""}`}
          >
            <span className={styles.label}>Last Take Profit Limit Order:</span>
            <span className={`${styles.limitOrderStatus}`}>
              {!isTakeProfitSuccessfully && <IoCloseCircle color={"red"} />}
              {isTakeProfitSuccessfully && (
                <IoCheckmarkDoneCircle color={"green"} />
              )}
              {lastTakeProfit}
            </span>
          </li>
        )}
        {lastStopLoss && (
          <li
            className={`${!isStopLossSuccessfully ? styles.failedOrder : ""}`}
          >
            <span className={styles.label}>Last Stop Loss Limit Order:</span>
            <span className={`${styles.limitOrderStatus}`}>
              {!isStopLossSuccessfully && <IoCloseCircle color={"red"} />}
              {isStopLossSuccessfully && (
                <IoCheckmarkDoneCircle color={"green"} />
              )}
              {lastStopLoss}
            </span>
          </li>
        )}
      </ul>
    </div>
  );
}

export default ComprehensiveHistoryTableExpandedRow;
